import * as React from 'react';
import * as firebase from 'firebase/app';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';
import { Dispatch, connect } from 'react-redux';
import { AppState, Category, CollectionState } from 'src/store';
import { TextField } from 'redux-form-antd';
import { actions as toast } from 'src/toast';
import { Button, Card, Row, Col } from 'antd';
import { push } from 'react-router-redux';
import { RouteComponentProps } from 'react-router';
import { required } from 'src/reduxFormAntd/validations';
import { actions } from '../redux';
import { Subscription } from 'rxjs';
import { actions as categoryActions } from '../../categories/redux';
import { TreeSelectField, InputNumberField } from 'src/reduxFormAntd';
import { TreeNode } from 'antd/lib/tree-select';

const formItemLayout = {
    labelCol: {
        xs: { span: 12 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 15 },
    },
};

const mapStateToProps = (appState: AppState, props: Props) => {
    const { featuredCategoryDetailState, categoriesState } = appState;
    const { match: { params: { id } } } = props;
    let initialValues: Partial<FormData> = { name: '' };
    if (id && featuredCategoryDetailState.status === 'loaded') {
        const {
            name,
            categories,
            sorter,
        } = featuredCategoryDetailState.data;

        const categoryIds: string[] = [];
        if (categories && categories.length > 0) {
            categories.forEach((category) => {
                categoryIds.push(category.id)
            })
        }
        initialValues = { name, categoryIds, sorter };
    }
    const loading = (featuredCategoryDetailState.status === 'loading');
    return {
        id,
        initialValues,
        loading,
        categoriesState,
    };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        listen: (id: string | null) => {
            if (id) {
                dispatch(actions.listenDoc(id));
            }
            dispatch(categoryActions.listenCollection())
        },
        unlisten: () => {
            dispatch(actions.unlistenDoc());
            dispatch(categoryActions.unlistenCollection());
        }
    };
};

interface FormData {
    id?: string;
    name: string;
    sorter: number;
    categoryIds: string[];
    Sorter: number;
}

interface Props extends InjectedFormProps<FormData>, RouteComponentProps<{ id: string | null }> {
    id: string | null;
    loading: boolean;
    categoriesState: CollectionState<Category>;
    listen: (id: string | null) => void;
    unlisten: () => void;
}

function getTree(data: Category[], parentId: string | null): TreeNode[] {
    const categorys = data.filter(d => d.parentId === parentId).sort((a, b) => a.name.localeCompare(b.name));
  
    return categorys.map(i => {
      return {
        key: i.id.toString(),
        value: i.id.toString(),
        title: i.name,
        children: getTree(data, i.id),
      };
    });
  }
  const filterTreeNodeFn =// tslint:disable-next-line:no-any
    (inputValue: string, treeNode: any) =>
      treeNode.props.title.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
      
class CreateOrEditFeaturedCategory extends React.Component<Props> {
    subscription: Subscription;

    constructor(props: Props) {
        super(props);
        this.state = { status: 'none' };
        this.subscription = new Subscription();
    }

    componentDidMount() {
        const { id, listen } = this.props;
        listen(id);

    }

    componentWillUnmount() {
        const { unlisten } = this.props;
        unlisten();
    }

    delete = async (values: FormData, dispatch: Dispatch<AppState>) => {
        const { id } = this.props;
        const ref = firebase.firestore().collection('featuredCategories');
        if (id) {
            const doc = ref.doc(id)
            await doc.delete()
            dispatch(toast.success('Featured Category is deleted successfully.'));
            dispatch(push('/featuredCategories'));
        }
    }

    submit = async ({ id, ...values }: FormData, dispatch: Dispatch<AppState>) => {
        const { categoriesState } = this.props;
        const allCategory = categoriesState.status === 'loaded' ? categoriesState.data : [];

        const categories: Category[] = []
        let category: Category | undefined;
        if (values.categoryIds.length > 0) {
            values.categoryIds.forEach((categoryId) => {
                category = allCategory.find(c => c.id === categoryId);
                if (category) {
                    categories.push(category)
                }
            })
        }

        const addFeaturedAds = firebase.functions().httpsCallable('addFeaturedCategory');
        await addFeaturedAds({
            id: id || this.props.id,
            ...values,
            categories,
        });
        dispatch(toast.success('Featured Category is added successfully.'));
        dispatch(push('/featuredCategories'));
    }

    render() {
        const { handleSubmit, submitting, loading, id, categoriesState } = this.props;
        const treeData = getTree(
            categoriesState.status === 'loaded' ?
              categoriesState.data : [],
            null
          );

        return (
            <Card
                loading={loading}
                title={`${id ? 'Edit' : 'Create'} Featured Category`}
                bordered={true}
                bodyStyle={{ padding: 0 }}
            >
                <form onSubmit={handleSubmit(this.submit)} className="ant-form ant-form-horizontal code-box">
                    <section className="last">
                        <Row>
                            <Col span={12}>
                                {/* <CategoryTreeSelect
                                    name="categoryIds"
                                    label="Categories"
                                    placeholder="Categories"
                                    {...formItemLayout}
                                    multiple={true}
                                    categoriesState={categoriesState}
                                    validate={[required]}
                                /> */}
                                <Field
                                    name="categoryIds"
                                    label="Categories"
                                    placeholder="Categories"
                                    {...formItemLayout}
                                    component={TreeSelectField}
                                    treeSelectProps={{
                                        showSearch: true,
                                        allowClear: true,
                                        dropdownStyle: { maxHeight: 400, overflow: 'auto' },
                                        treeData,
                                        treeDefaultExpandAll: true,
                                        filterTreeNode: filterTreeNodeFn,
                                        multiple: true
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Field
                                    name="name"
                                    label="Name"
                                    {...formItemLayout}
                                    component={TextField}
                                    placeholder="Ads name"
                                    validate={[required]}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Field
                                    name="sorter"
                                    label="Sorter"
                                    {...formItemLayout}
                                    component={InputNumberField}
                                    placeholder="Sorter"
                                    validate={[required]}
                                />
                            </Col>
                        </Row>
                    </section>
                    <section className="action-panel">
                        <Button type="primary" htmlType="submit" loading={submitting} icon="save">Save</Button>
                    </section>
                </form>
            </Card>
        );
    }
}

// tslint:disable-next-line:no-any
const F: any = reduxForm<FormData>({
    form: 'createOrEditFeaturedCategory',
    enableReinitialize: true,
})(CreateOrEditFeaturedCategory);
export default connect(mapStateToProps, mapDispatchToProps)(F);



// WEBPACK FOOTER //
// ./src/featuredCategories/forms/CreateOrEditFeaturedCategory.tsx